import Logo from "../Atoms/Logo";
import BurgerMenu from "../Atoms/BurgerMenuButton";
import { useAppSelector } from "Redux/hooks";
import { selectStyle } from "Redux/appSlice";

type Props = {
  children: React.ReactNode;
  onMenuClick?: () => void;
};

function Bar({ children, onMenuClick }: Props) {
  const { color1, logo } = useAppSelector(selectStyle);
  return (
    <div
      className="m-auto flex items-center justify-between p-2 align-middle"
      style={{ background: color1 }}
    >
      <Logo image={logo} />

      {children}
      <BurgerMenu onClick={onMenuClick} />
    </div>
  );
}

export default Bar;
